<span class="mbm-badge mbm-badge-{{variant()}}">{{ label() ?? (labelKey()! | translate) }}</span>
